module.exports = __webpack_public_path__ + "static/media/arrow_under_tablet_icon.0598c587.svg";